import React from "react";
import { Button, Modal } from "react-bootstrap";
import { IEvent } from "./EventCalendar";
import { useDateTime } from "../../../hooks";

type Props = {
  show: boolean;
  onClose: (update: boolean) => void;
  event?: IEvent;
  updateEventAllowed?: boolean;
};

const EventDetails: React.FC<Props> = ({ show, onClose, event, updateEventAllowed }) => {
  const { displayDate: startDateFormatted } = useDateTime({
    date: event?.start,
    showTime: !event?.allDay,
    includeRelative: false
  });

  const { displayDate: endDateFormatted } = useDateTime({
    date: event?.end,
    showTime: !event?.allDay,
    includeRelative: false
  });

  const handleClose = () => onClose(false);

  const renderEventInfo = () => {
    if (!event) return null;

    return (
      <div className="event-info">
        <h5>{event.title}</h5>
        <p><strong>Start:</strong> {startDateFormatted}</p>
        {event?.end && event.end !== event.start && (
          <p><strong>End:</strong> {endDateFormatted}</p>
        )}
        {event.description && (
          <p><strong>Description:</strong> {event.description}</p>
        )}
        {event.identityName && (
          <p><strong>Assigned to:</strong> {event.identityName}</p>
        )}
      </div>
    );
  };

  return (
    <Modal centered show={show} keyboard={false} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Event Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {renderEventInfo()}
      </Modal.Body>
      <Modal.Footer>
        <div className="form-group">
          {updateEventAllowed && (
            <Button
              variant="primary"
              onClick={() => onClose(true)}
              className="me-2"
            >
              Update Event
            </Button>
          )}
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export { EventDetails };

